/* eslint-disable */
<template>
  <section v-if="!loadingNew" class="main-user-data">
    <section v-if="!loadingNew" class="detail-policy-info">
      <header-contract-components :header="header" />
      <info-components :headInfo="headInfo" :infoData="infoData" />
      <DidNewComponent v-if="visible.did" @emptyValues="visible.did = false"/>
    </section>
  </section>
  <preloader-component v-if="loading" />
  <section v-if="!loading" class="main-user-data">
    <section v-if="!loading" class="detail-policy-info">
      <client-components
        v-if="contract.clients"
        :data="contract.clients"
      />
      <div v-if="productType === 'pf'">
        <ChartNewComponent
          @getChartData="this.chartData = $event"
        />
        <div class="policy-accardion policy-accardion-active">
          <div @click="visible.portfolioStructure = !visible.portfolioStructure" class="policy-accardion-header dropdown-div">
            <div class="policy-accardion-title">Структура портфеля</div>
            <img
              v-if="!visible.portfolioStructure"
              src="@/profile/assets/icons/arrow-bottom.svg" alt="arrow-bottom" class="dropdown-img"
            >
            <img
              v-else
              src="@/profile/assets/icons/arrow-top.svg" alt="arrow-top" class="dropdown-img"
            >
          </div>
          <PortfolioStructure
            v-if="briefcaseInfo && visible.portfolioStructure"
            :briefcaseInfo="briefcaseInfo"
          />
        </div>
      </div>
      <div v-if="contract.pt === 'isz' && productType !== 'pf'" class="subgroup" id="subgroup-chart">
        <chart-component2 />
      </div>
      <div v-if="contract.coupon_barriers && contract.coupon_barriers.data && contract.pt !== 'cred'"
           class="policy-accardion policy-accardion-active">
        <div @click="visible.barriers = 1 - visible.barriers" class="policy-accardion-header dropdown-div">
          <div class="policy-accardion-title">Купонные барьеры</div>
          <img
            v-if="visible.barriers === 0"
            src="@/profile/assets/icons/arrow-bottom.svg" alt="arrow-bottom" class="dropdown-img"
          >
          <img
            v-if="visible.barriers === 1"
            src="@/profile/assets/icons/arrow-top.svg" alt="arrow-top" class="dropdown-img"
          >
        </div>
        <barrier-component
          v-if="visible.barriers"
          :barriers="contract.coupon_barriers.data"
        />
      </div>
      <div v-if="contract.risks" class="policy-accardion policy-accardion-active">
        <div @click="visible.risks = 1 - visible.risks" class="policy-accardion-header dropdown-div">
          <div class="policy-accardion-title">Страховые риски</div>
          <img
            v-if="visible.risks === 0"
            src="@/profile/assets/icons/arrow-bottom.svg" alt="arrow-bottom" class="dropdown-img"
          >
          <img
            v-if="visible.risks === 1"
            src="@/profile/assets/icons/arrow-top.svg" alt="arrow-top" class="dropdown-img"
          >
        </div>
        <risks-component
          v-if="visible.risks && contract.risks.type !== 'group'"
          :type="contract.risks.type"
          :risks="contract.risks.data"
          :project_visible="visible.indexing_content"
          :project_state="contract.project.state"
          :productType="productType"
        />
        <grouped-risks-component
          v-if="visible.risks && contract.risks.type === 'group'"
          :risks="contract.risks.data"
          :project_visible="visible.indexing_content"
          :project_state="contract.project.state"
          :productType="productType"
        />
      </div>
      <!--      временный костыль   -->
      <div v-if="contract.redemption_amounts && contract.pt !== 'cred' && contract.pr !== 'ky'">
        <div @click="visible.ra = 1 - visible.ra" class="ra ra-contract">
          <h3>Сведения о выкупных суммах</h3>
          <img
            v-if="visible.ra === 0"
            src="@/profile/assets/icons/arrow-bottom.svg" alt="arrow-bottom"
          >
          <img
            v-if="visible.ra === 1"
            src="@/profile/assets/icons/arrow-top.svg" alt="arrow-top"
          >
          <div class="ra__accardion" v-if="visible.ra">
            <ra-component
              :ra="contract.redemption_amounts.data"
              :project_visible="visible.indexing_content"
              :project_state="contract.project.state"
            />
          </div>
        </div>
      </div>
      <div v-if="contract.premiums" class="policy-accardion policy-accardion-active">
        <div @click="visible.pays = !visible.pays" class="policy-accardion-header dropdown-div">
          <div class="policy-accardion-title">Оплата страховых взносов</div>
          <img
            v-if="!visible.pays"
            src="@/profile/assets/icons/arrow-bottom.svg" alt="arrow-bottom" class="dropdown-img"
          >
          <img
            v-else
            src="@/profile/assets/icons/arrow-top.svg" alt="arrow-top" class="dropdown-img"
          >
        </div>
        <pay-component
          v-if="visible.pays"
          :pays="contract.premiums.data"
          :to_pay="contract.premiums.to_pay"
          :invoices="contract.premiums.invoices"
          :email="contract.header.info.insurer_email.value"
          :project_visible="visible.indexing_content"
          :project_state="contract.project.state"
          :project_id="contract.project.project_id ? contract.project.project_id : ''"
          :autopay_data="contract.autopay"
          :contract_id="id"
          :po="contract.po"
          :pr="contract.pr"
          @changeprojectvisible2="changeprojectvisible1()"
        />
      </div>
      <div class="policy-accardion policy-accardion-active">
        <div @click="visible.statements = 1 - visible.statements" class="policy-accardion-header dropdown-div">
          <div class="policy-accardion-title">Поданные заявления</div>
          <img
            v-if="visible.statements === 0"
            src="@/profile/assets/icons/arrow-bottom.svg" alt="arrow-bottom" class="dropdown-img"
          >
          <img
            v-if="visible.statements === 1"
            src="@/profile/assets/icons/arrow-top.svg" alt="arrow-top" class="dropdown-img"
          >
        </div>
        <statements-component
          v-if="visible.statements"
          :statements="contract.statements"
          :contract_id="contract.root_id"
          :type="contract.pt"
          :status_doc="contract.status_doc"
        />
      </div>
      <div v-if="contract.pt !== 'cred' && contract.years_reference" class="policy-accardion policy-accardion-active form">
        <div @click="visible.help = 1 - visible.help" class="policy-accardion-header dropdown-div">
          <div class="policy-accardion-title">Справка для налогового вычета</div>
          <img
            v-if="visible.help === 0"
            src="@/profile/assets/icons/arrow-bottom.svg" alt="arrow-bottom" class="dropdown-img"
          >
          <img
            v-if="visible.help === 1"
            src="@/profile/assets/icons/arrow-top.svg" alt="arrow-top" class="dropdown-img"
          >
        </div>
        <div class="helpContract" v-if="visible.help">
          <div class="helpContract__text">
            Для получения справки необходимо обратиться в Страховую компанию с письменным заявлением.<br/>
            По взносам, оплаченным в <strong>2024 г.</strong><br/>
            Действует упрощенный порядок получения вычетов по НДФЛ. Страховая компания передаст электронные сведения напрямую в ФНС.<br/>
            По взносам, оплаченным <strong>до 2024 г.</strong><br/>
            Упрощенный порядок получения вычетов НДФЛ не действует, в ФНС необходимо предоставить полный комплект документов.<br/>
            Справка по новой форме будет направлена по адресу, указанному в заявлении.<br/>
            <br/>
            Подробнее с информацией о порядке получения вычетов можно ознакомиться по ссылке <a target="_blank" href="https://www.nalog.gov.ru/rn77/ndfl_easy/">https://www.nalog.gov.ru/rn77/ndfl_easy/</a>
            <div>
              <MakcButtonComponent
                @click="tax_statement"
                class="primary"
                style="float: none;">
                Сформировать заявление в Страховую компанию
              </MakcButtonComponent>
            </div>

          </div>
        </div>
      </div>
      <div class="subgroup" v-if="contract.inv_reports && contract.pt !== 'cred'">
        <div class="subgroup-title" v-html="contract.inv_reports.head"></div>
        <a
          v-for="(row, key) in contract.inv_reports.data" :key="key"
          target="_blank" :href="row.url" class="doc-wrapper"
        >
          <div class="left-content">
            <i class="doc-icon"></i>
            <div class="doc-text-left" v-html="row.name"></div>
          </div>
          <div class="right-content">
            <div class="doc-text-right">PDF</div>
            <i class="download-icon"></i>
          </div>
        </a>
      </div>
      <div class="subgroup" v-if="contract.inv_results && contract.pt !== 'cred'">
        <div class="subgroup-title" v-html="contract.inv_results.head"></div>
        <a
          v-for="(row, key) in contract.inv_results.data" :key="key"
          target="_blank" :href="row.url" class="doc-wrapper"
        >
          <div class="left-content">
            <i class="doc-icon"></i>
            <div class="doc-text-left" v-html="row.name"></div>
          </div>
          <div class="right-content">
            <div class="doc-text-right">PDF</div>
            <i class="download-icon"></i>
          </div>
        </a>
      </div>
    </section>
  </section>
</template>

<script>
import PreloaderComponent from "@/profile/components/PreloaderComponent.vue";
import PayComponent from "@/profile/components/PayComponent.vue"; //+?? todo перейти на не-App стили
import RaComponent from "@/profile/components/RaComponentNew.vue"; //+
import GroupedRisksComponent from "@/profile/components/GroupedRisksComponent.vue"; //+?? todo перейти на не-App стили
import RisksComponent from "@/profile/components/RisksComponent.vue"; //+?? todo перейти на не-App стили
import BarrierComponent from "@/profile/components/BarrierComponent.vue"; //+?? todo перейти на не-App стили
import InfoComponents from "@/profile/components/InfoComponents.vue"; //+
import StatementsComponent from "@/profile/components/StatementsComponent.vue"; //+?? todo перейти на не-App стили
import ClientComponents from "@/profile/components/ClientComponents.vue"; //+
import HeaderContractComponents from "@/profile/components/HeaderContractComponents.vue"; //+
import DidNewComponent from "@/profile/components/DidNewComponent.vue"; //+?? todo перейти на не-App стили
import ChartNewComponent from "@/profile/components/ChartNewComponent"; //+?
import ChartComponent2 from "@/profile/components/ChartComponent2.vue";
import axios from "axios";
import { url } from "@/profile/composables/url";
import { formatDate } from "@/profile/composables/utils";
import PortfolioStructure from "@/profile/components/portfolioStructure/PortfolioStructure.vue";
import MakcButtonComponent from "@/profile/components/UI/MakcButtonComponent.vue";

export default {
  // eslint-disable-next-line
  name: "ContractView",
  props: ["id"],
  data: () => {
    return {
      contract: {
        pt: "cred"
      },
      unitPoints: null,
      headInfo: null,
      infoData: null,
      productType: null,
      briefcaseInfo: null,
      header: {},
      bonuses: {},
      names: {},
      visible: {
        barriers: 0,
        risks: 0,
        indexing: 0,
        indexing_content: 1,
        ra: 0,
        pays: false,
        portfolioStructure: false,
        help: 0,
        did: true,
        statements: 1
      },
      loading: true,
      loadingNew: true,
      toEmail: false,
      toUrl: false,
      email: "",
      year: "",
      refResult: "",
      contract_props: {},
      chartData: []
    };
  },
  computed: {},
  created() {
    // загружаем данные, когда представление создано
    // и данные реактивно отслеживаются
    this.fetchData();
    this.getIds();
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    $route: "fetchData"
  },
  methods: {
    tax_statement() {
      this.$router.push({ name: "taxcert", params: { id: this.id } });
    },
    changeprojectvisible1() {
      this.visible.indexing_content = !this.visible.indexing_content;
    },
    fetchData() {
      this.$myApp.contract.on((value) => {
        this.contract_props = value;
      });
      let params = {
        command: "contract",
        contract_id: this.$route.params.token ? this.$route.params.id : this.id,
        token: this.$route.params.token ? this.$route.params.token : this.$myApp.token.get()
      };
      let $this = this;
      axios.post(url, { params: params })
        .then(function(response) {
          let data = response.data;
          if (data.state === "ERR") {
            if (data.msg_no == 3) {
              $this.$router.push({ name: "login" });
            }
            $this.errors = [];
            $this.errors.push(data.msg_text);
          }
          if (data.state === "OK") {
            if (data.menu) {
              $this.$myApp.menu.set(data.menu);
            }
            $this.contract = data.contract;
            $this.visible.indexing_content = data.contract.project && data.contract.project.state ? 1 : 0;
            $this.names = data.names;
            $this.loading = false;
            $this.$forceUpdate();
          }
        })
        .catch(function(error) {
          console.log(error);
          $this.errors = [];
          $this.errors.push("Возникла ошибка, попробуйте позже");
          $this.loading = false;
        });
    },
    getReference() {
      this.refResult = "".concat(
        "Вы выбрали: год ", this.year, this.toEmail ? "".concat(", email ", this.email) : ""
        , this.toUrl ? ", получить ссылку" : "", "\\nПодождите, идет формирование справки!"
      );
      let params = {
        command: "reference",
        year: this.year,
        is_email: this.toEmail,
        email: this.email,
        is_url: this.toUrl,
        contract_id: this.$route.params.token ? this.$route.params.id : this.id,
        token: this.$route.params.token ? this.$route.params.token : this.$myApp.token.get()
      };
      let $this = this;
      axios.post(url, { params: params })
        .then(function(response) {
          let data = response.data;
          if (data.state === "ERR") {
            let resMess = "".concat(
              data.msg_text, ": ", data.detailed
            );
            $this.refResult = "<div class=\"alert alert-danger\">" + resMess + "</div>";
          }
          if (data.state === "OK") {
            if ($this.toUrl) {
              $this.refResult = "<div class=\"alert alert-success\">" + data.msg + "</div><a href=\"" + data.file + "\" target=\"_blank\">Скачать</a>";
            } else {
              $this.refResult = "<div class=\"alert alert-success\">" + data.msg + "</div>";
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    async getIds() {
      const api = await this.$api2.get({
        action: "get-ids-by-agreement",
        object: "cpa",
        agreement_id: this.$route.params.token ? this.$route.params.id : this.id,
        token: this.$route.params.token ? this.$route.params.token : this.$myApp.token.get()
      });
      if (api.success) {
        this.$myApp.contract.set(api.data.contract);
        await this.getContractHeader();
        await this.getContractDetails();
        if (this.productType === "pf") {
          await this.getContractUnit();
          await this.getContractBriefcase();
        }
        this.loading = false;
        this.loadingNew = false;
      }
    },
    async getContractHeader() {
      const contract = this.$myApp.contract.get();
      const api = await this.$api2.get({
        action: "get-contract-header",
        object: "cpa",
        agreement_id: this.$route.params.token ? this.$route.params.id : this.id,
        contract_id: this.$route.params.token ? this.$route.params.id : this.id,
        version_id: this.$route.params.token ? this.$route.params.id : contract.version_id,
        cover_id: this.$route.params.token ? this.$route.params.id : contract.cover_id,
        document_id: this.$route.params.token ? this.$route.params.id : contract.document_id,
        token: this.$route.params.token ? this.$route.params.token : this.$myApp.token.get()
      });
      if (api.success) {
        this.header = api.data.header;
        this.$myApp.client.set(api.data.client.id);
      }
    },
    async getContractDetails() {
      const contract = this.$myApp.contract.get();
      const api = await this.$api2.get({
        action: "get-contract-details",
        object: "cpa",
        agreement_id: this.$route.params.token ? this.$route.params.id : contract.agreement_id,
        contract_id: this.$route.params.token ? this.$route.params.id : this.id,
        version_id: this.$route.params.token ? this.$route.params.id : contract.version_id,
        cover_id: this.$route.params.token ? this.$route.params.id : contract.cover_id,
        document_id: this.$route.params.token ? this.$route.params.id : contract.document_id,
        token: this.$route.params.token ? this.$route.params.token : this.$myApp.token.get()
      });
      if (api.success) {
        this.headInfo = api.data.details.head;
        this.$myApp.tech.set(api.data.details.tech);
        this.productType = api?.data?.details["tech"]["it"]["value"]; // шторм ругается на слова tech и it, поэтому так
        if (api.data.details["tech"]["it"]["value"] === "pf") { // продукт Инвестор / ПИФ (графики в ДСЖ)
          const x = api.data.details.info;
          delete x.date_expiration;
          delete x.insurance_amount;
          delete x.profit;
          delete x.project;
          delete x.particion_coef;
          this.infoData = x;
        } else {
          // console.log(`222`);
          // console.log(api.data.details.tech.pr);
          this.infoData = api.data.details.info;
          // временный костыль
          if (api.data.details.tech.pr.value === "ky") {
            // console.log(`333`);
            delete this.infoData.insurance_amount;
            delete this.infoData.premia;
          }
          //костыль, не могут объяснить почему приходит с бэка
          delete this.infoData.statements;
        }
      }
    },
    async getContractBriefcase() {
      const contract = this.$myApp.contract.get();
      const api = await this.$api2.get({
        action: "get-contract-briefcase",
        object: "cpa",
        agreement_id: this.$route.params.token ? this.$route.params.id : this.id,
        contract_id: this.$route.params.token ? this.$route.params.id : this.id,
        version_id: this.$route.params.token ? this.$route.params.id : contract.version_id,
        cover_id: this.$route.params.token ? this.$route.params.id : contract.cover_id,
        document_id: this.$route.params.token ? this.$route.params.id : contract.document_id,
        strategy_id: this.header.info.strategy.id,
        token: this.$route.params.token ? this.$route.params.token : this.$myApp.token.get()
      });
      if (api.success) {
        this.briefcaseInfo = api.data.briefcase.data;
      }
    },
    async getContractUnit() {
      const contract = this.$myApp.contract.get();
      const api = await this.$api2.get({
        action: "get-contract-unit",
        object: "cpa",
        agreement_id: this.$route.params.token ? this.$route.params.id : this.id,
        contract_id: this.$route.params.token ? this.$route.params.id : this.id,
        version_id: this.$route.params.token ? this.$route.params.id : contract.version_id,
        cover_id: this.$route.params.token ? this.$route.params.id : contract.cover_id,
        document_id: this.$route.params.token ? this.$route.params.id : contract.document_id,
        token: this.$route.params.token ? this.$route.params.token : this.$myApp.token.get()
      });
      if (api.success) {
        const res0 = api.data.unit.data.data.invest_date;
        const res = api.data.unit.data.data.calc_date;

        this.infoData.invest_date_amount = {
          title: `Стоимость юнита на дату инвестирования`,
          value: res0.amount.value && res0.date.value ? (Math.round(res0.amount.value * 100) / 100).toFixed(2) : `Будет определена после даты инвестирования`
        };
        this.infoData.invest_date_quantity = {
          title: `Количество юнитов на дату инвестирования`,
          value: res0.quantity.value && res0.date.value ? (Math.round(res0.quantity.value * 100000) / 100000).toFixed(5) : `Будет определено после даты инвестирования`
        };

        this.infoData.calc_date_amount = {
          title: res.amount.value && res.quantity.value && res.date.value ? `Стоимость юнита на ${formatDate(res.date.value)}` : `Стоимость юнита`,
          value: res.amount.value && res.quantity.value && res.date.value ? (Math.round(res.amount.value * 100) / 100).toFixed(2) : `Будет определена после даты инвестирования`
        };
        this.infoData.calc_date_quantity = {
          title: res.amount.value && res.quantity.value && res.date.value ? `Количество юнитов на ${formatDate(res.date.value)}` : `Количество юнитов`,
          value: res.amount.value && res.quantity.value && res.date.value ? (Math.round(res.quantity.value * 100000) / 100000).toFixed(5) : `Будет определено после даты инвестирования`
        };
      }
    }
  },
  components: {
    MakcButtonComponent,
    PortfolioStructure,
    ChartComponent2,
    DidNewComponent,
    HeaderContractComponents,
    PayComponent,
    RaComponent,
    GroupedRisksComponent,
    RisksComponent,
    BarrierComponent,
    InfoComponents,
    StatementsComponent,
    ChartNewComponent,
    ClientComponents,
    PreloaderComponent
  }
};
</script>

<style>
.left-block {
  display: block;
  float: left;
}

.right-block {
  display: block;
  float: right;
}

@media screen and (max-width: 760px) {
  .left-block,
  .right-block {
    float: none;
    width: 100%;
    text-align: center;
  }

}

.help > .body {
  position: relative;
}

.help > .body > div {
  display: none;
  position: absolute;
  bottom: 2em;
  right: -5em;
  padding: .25em;
  background: #ffffdd;
  font-size: 75%;
  min-width: 13em;
  line-height: normal;
  border-radius: 0.35em;
  text-align: center;
  box-shadow: 0.1em 0.1em 0.25em #555555;
}

.help:hover > .body > div {
  display: block;
}

.alert-info {
  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb;
}

#subgroup-chart {
  page-break-inside: avoid;
}

</style>
